/* eslint-disable new-cap */
import React from 'react';
import PropTypes from 'prop-types';

import request from '../../../utils/request';
import { Expired, MultiSiteTag } from './css';
import Comment from '../../../orders/comment';
import Row from './row';

import { orderStatus } from '../../../utils/constant';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import Tag from '../../../common/tags';

const TableBody = ({
  keys,
  data,
  actions,
  dataModel = {},
  actionsDisplay = 'flex',
  callback = () => {},
  header
}) => {
  const getFeilds = (cell, cellKey, row, rowData, isChildRow) => {
    const localizedStrings = useLocalizedStringsContext();
    const {
      sovTableMessages: { resendContract, returnOrder }
    } = localizedStrings.ORDERS;
    const {
      id,
      isContractResend,
      isOrderReturned,
      isLockedBy,
      wgInstallationDate
    } = row;
    const { email } = request.getProfile();
    switch (cell) {
      case 'comments':
        return (
          <Comment
            id={cellKey}
            comment={
              rowData[cell] && rowData[cell].length > 0
                ? rowData[cell][0].text
                : ''
            }
          />
        );
      case 'orderStatus':
        return (
          <>
            {row.status === orderStatus.contractExpired ? (
              <Expired>{rowData[cell]}</Expired>
            ) : (
              rowData[cell]
            )}
          </>
        );
      case 'messages':
        return (
          <div className="responsive-table__messages">
            {isContractResend && (
              <Tag
                orderId={id}
                tagKey="isContractResend"
                tagLabel={resendContract}
                callback={callback}
              />
            )}
            {isOrderReturned && (
              <Tag
                orderId={id}
                tagKey="isOrderReturned"
                tagLabel={returnOrder}
                callback={callback}
              />
            )}
            <p style={{ fontSize: '12px', fontWeight: '500' }}>
              {isLockedBy &&
                isLockedBy !== email &&
                `This order is being currently worked on by ${isLockedBy}`}
            </p>
            {wgInstallationDate && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  fontSize: '12px',
                  fontWeight: '500'
                }}
              >
                <p>Technician visit:</p>
                <p>{wgInstallationDate}</p>
              </div>
            )}
          </div>
        );
      case 'orderId':
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            {row.orderId}
            {isChildRow && (
              <MultiSiteTag color="#6aca25">{`Site: ${row.currentSite}`}</MultiSiteTag>
            )}
          </div>
        );
      default:
        return <>{rowData[cell]}</>;
    }
  };

  return (
    <tbody className="responsive-table__tbody">
      {data.map((row, rowIndex) => {
        return (
          <Row
            row={row}
            rowIndex={rowIndex}
            getFeilds={getFeilds}
            actions={actions}
            dataModel={dataModel}
            actionsDisplay={actionsDisplay}
            keys={keys}
            header={header}
          />
        );
      })}
    </tbody>
  );
};

TableBody.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.func.isRequired,
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  actionsDisplay: PropTypes.string,
  callback: PropTypes.func,
  header: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default TableBody;
